/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledDuoButtonsTypes = {
    primary: "primary" as const
    // secondary: 'secondary' as 'secondary'
};

export type StyledDuoButtonsTypes = typeof StyledDuoButtonsTypes[keyof typeof StyledDuoButtonsTypes];
